const validate = (values = {}) => {
	const errors = {};

	if (!values.name) errors.name = "Informe nome do departamento";

	return errors;
};

export default validate;
